import React, { Component } from 'react';
import Validation from '../utils/validation';
import RegisterHelper from '../../../jotun-registration/src/helpers/register';

require('../../../jotun-registration/src/css/register.css');
require('../../../jotun-registration/src/css/register-blogg.css');

export default class Register extends Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.renderDefault = this.renderDefault.bind(this);
        this.state = {
            validation_error: '',
            registered: false,
            acceptedTerms: false,
            content: {}
        }
        this.text = [
            { no:
                {
                    lang:               "no",
                    heading:            "NYHETSBREV!",
                    leadin:             "Hold deg oppdatert på farger og trender gjennom vårt nyhetsbrev.",
                    batLeadin:          "Hold deg oppdatert på nyheter og gode tips gjennom vårt nyhetsbrev.",
                    success:            "Takk, du vil nå motta vårt nyhetsbrev!",
                    button:             "Meld på!",
                    terms:              "Jeg samtykker til å motta Jotuns nyhetsbrev og er informert om at et slikt samtykke kan trekkes tilbake",
                    termsLink:          "https://www.jotun.com/no/no/b2c/TermsandconditionsB2C.aspx",
                    termsLinkText:      "her"
                }
            },
            { se:
                {
                    lang:               "se",
                    heading:            "NYHETSBREV!",
                    leadin:             "Håll dig uppdaterad på kulörer och trender med vårt nyhetsbrev.",
                    success:            "Tack för ditt intresse! Du kommer snart att få vårt nyhetsbrev.",
                    button:             "Anmäl dig här!",
                    terms:              "Jag samtycker till att ta emot Jotuns nyhetsbrev och är informerad om att samtycket kan dras tillbaka",
                    termsLink:          "https://www.jotun.com/se/se/b2c/TermsandconditionsB2C.aspx",
                    termsLinkText:      "här"
                }
            }
        ];
    }

    componentWillMount(){
        let selectedLang = this.props.lang;
        let ret;
        this.text.forEach(function(lang){
            let keys = Object.keys(lang);
            for(let index in keys){
               if(keys[index]===selectedLang){
                   ret = Object.assign({},lang[selectedLang]);
               }
            }
        });
        this.setState({content:ret});
    }

    handleSubmit(e){
        e.preventDefault();

        if(!this.state.acceptedTerms){
            this.setState({validation_error:'Please accept our terms and conditions.'});
            return;
        }

        if(Validation.validateEmail(e.target['rule_email'].value)){

            RegisterHelper.registerEmail(
                e.target['rule_email'].value,
                this.props.lang,
                this.props.media
            )
            .then((res)=>{
                this.setState({registered:true});
            })
            .catch((err)=>{console.log(err)});

        }
        else
            this.setState({validation_error:'This is not a valid email. Please try again.'});
    }

    renderValidationError(){
        if(this.state.validation_error!==''){
            return (
                <span className="error">{this.state.validation_error}</span>
            );
        }
    }

    renderForm(){
        if(this.state.registered)
            return (
                <div className="rulemailer-subscriber-widget">
                    <p>{this.state.content.success}</p>
                </div>
            );

        return (
            <div className="rulemailer-subscriber-widget">
                <form onSubmit={this.handleSubmit}>
                    <input type="email" placeholder="E-post" id="rule_email" required="required" onChange={()=>this.setState({validation_error:''})}/>
                    <button type="submit" disabled={!this.state.acceptedTerms}>{this.state.content.button}</button>
                    <label>
                        <input type="checkbox" name="terms" value={this.state.acceptedTerms} onChange={(e)=>this.setState({acceptedTerms:e.target.checked})}/>
                        {this.state.content.terms} <a href={this.state.content.termsLink} target="_blank">{this.state.content.termsLinkText}</a>.
                    </label>
                </form>
                {this.renderValidationError()}
            </div>
        );
    }

    renderBlogg(){
        return(
            <div id="newsletter-signup-blogggg" className="clearfix">
                <div className="column left">
                    <div className="header">{this.state.content.heading}</div><br/>
                    {this.state.content.leadin}
                </div>
                <div className="column right">
                    {this.renderForm()}
                </div>
            </div>
        );
    }

    renderBatmagasinet(){
        return(
            <div id="newsletter-signup-blogggg" className="clearfix">
                <div className="column left">
                    <div className="header">{this.state.content.heading}</div><br/>
                    {this.state.content.batLeadin}
                </div>
                <div className="column right">
                    {this.renderForm()}
                </div>
            </div>
        );
    }

    renderDefault(){
        return (
            <div className="container">
                <div className="row">
                    <div className="twelve columns article ahref paragraphWrapper">
                        <div className="row">
                            <div className="twelve video-block left"></div>
                        </div>
                        <div className="row"></div>
                        <div className="qbrick-block video-container">
                            <div id="newsletter-signup" className="clearfix">
                                <div className="column left">
                                    <div className="header">{this.state.content.heading}</div><br/>
                                    {this.state.content.leadin}
                                </div>
                                <div className="column right">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if(this.props.media==='blogg' || this.props.media==='exterior')
            return this.renderBlogg();

        if(this.props.media==='batmagasinet')
            return this.renderBatmagasinet();

        return this.renderDefault();
    }
}

Register.propTypes = {
    lang:   React.PropTypes.string.isRequired,
    media:  React.PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Register.js